module.exports = __webpack_public_path__ + "Send_Message.095b1d6e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/graphics/Send_Message.png
// module id = MWFH
// module chunks = 0